import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { GetActiveScalesApi } from "../../../api/GetActiveScalesApi";

const { Option } = Select;

function PlanGroupFilterModel(props) {
  const [submit, setSubmit] = useState(false);
  const [scales, setScales] = useState();
  const [form] = Form.useForm();

  console.log(props.filterBy);
  useEffect(() => {
    if (props.visible) {
      getScales();
      props.filterBy?.name &&
        form.setFields([{ name: "name", value: props.filterBy?.name }]);
    }
  }, [props.visible]);

  function handleCancel() {
    setSubmit(false);
    setScales();
    props.handleCancel();
    form.resetFields();
  }

  const onFinish = (values) => {
    setSubmit(true);
    props.handleOk(values);
    handleCancel();
  };

  async function getScales() {
    const apiResponse = await GetActiveScalesApi();
    if (apiResponse.success) {
      setScales(apiResponse.data);
      props.filterBy?.scale &&
        form.setFields([
          {
            name: "scale",
            value: props.filterBy?.scale,
          },
        ]);
    }
  }

  return (
    <Modal
      title="Filter plan groups"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="organizationFilter"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Group name" name="name">
          <Input placeholder="Group name" />
        </Form.Item>

        <Form.Item label="Default scale" name="scale">
          <Select
            showSearch
            placeholder="Select designation"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {scales?.map((typ) => {
              return (
                <Option key={typ.id} value={typ.id}>
                  {typ.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="w-28"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Filter"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default PlanGroupFilterModel;
